import { faPaperPlaneTop } from '@fortawesome/pro-solid-svg-icons/faPaperPlaneTop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import DropdownMenu, { ButtonTextWrapper, ChevronIcon, OpenerButton } from 'components/common/dropdown_menu_v2';
import Menu from 'components/common/menu';
import MenuIcon from 'components/lib/icons/menu_icon';

export function TeamAssistInput({ dataAid, dataAidSend, disabled, onChange, onKeyDown, onSubmit, placeholder, value }) {
  return (
    <InputWrapper>
      <StyledInput
        data-aid={dataAid}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        value={value}
      />
      <SendButton data-aid={dataAidSend} disabled={disabled} onClick={onSubmit} type="button">
        <FontAwesomeIcon icon={faPaperPlaneTop} style={{ fontSize: '12px' }} />
      </SendButton>
    </InputWrapper>
  );
}

TeamAssistInput.propTypes = {
  dataAid: PropTypes.string,
  dataAidSend: PropTypes.string,
  disabled: PropTypes.bool,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
};

TeamAssistInput.defaultProps = {
  dataAid: 'teamAssistInput',
  dataAidSend: 'teamAssistSendButton',
  disabled: false,
  placeholder: 'Chat with Gladly AI',
};

const InputWrapper = styled.div`
  position: relative;
`;

const StyledInput = styled.input`
  background: ${p => p.theme.colors.gray100};
  border: 1px solid ${p => p.theme.colors.gray300};
  border-radius: 24px;
  color: ${p => p.theme.colors.black};
  font-size: ${p => p.theme.fontSize.base};
  height: 48px;
  outline: none;
  padding: 0 46px 0 14px;
  width: 100%;
  &::placeholder {
    color: ${p => p.theme.colors.gray500};
  }
  &:focus {
    border-color: ${p => p.theme.colors.green400};
  }
`;

const SendButton = styled.button`
  align-items: center;
  background: ${p => (p.disabled ? p.theme.colors.gray300 : p.theme.colors.green400)};
  border: none;
  border-radius: 50%;
  color: ${p => p.theme.colors.white};
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  display: flex;
  height: 32px;
  justify-content: center;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  &:hover {
    background: ${p => (p.disabled ? p.theme.colors.gray300 : p.theme.colors.green300)};
  }
`;

export const TeamAssistActionsDropdown = styled(DropdownMenu)`
  ${ChevronIcon} {
    display: none;
  }

  ${ButtonTextWrapper} {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    width: auto;
  }
`;

export const TeamAssistActionsMenuOpener = styled(OpenerButton).attrs({
  'aria-haspopup': 'menu',
  'aria-label': 'Team Assist actions',
})`
  cursor: pointer;
  min-height: auto;
  padding: 4px 8px;

  &&,
  &&:active,
  &&:focus,
  &&:hover {
    background: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }

  .menuIcon {
    fill: ${p => p.theme.colors.gray600};
    height: 16px;
    width: 4px;
  }

  &&:hover {
    .menuIcon {
      fill: ${p => p.theme.colors.green400};
    }
  }
`;

export const TeamAssistActionsMenuIcon = styled(MenuIcon)`
  color: currentColor;
`;

export const TeamAssistModalActionsMenu = styled(Menu)`
  z-index: 40;
`;

export const TeamAssistPanelActionsMenu = styled(Menu)`
  z-index: 30;
`;
